import { portalAPI } from './portalAPI';

const APINetvisorSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['Netvisor'] }).injectEndpoints({
    endpoints: (builder) => ({
        isNetvisorIntegrationEnabled: builder.query<boolean, void>({
            query: () => '/v1/integrations/netvisor/enabled',
            keepUnusedDataFor: 10 * 60,
        }),
    }),
    overrideExisting: false,
});

export const { useIsNetvisorIntegrationEnabledQuery } = APINetvisorSlice;
